import React from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'

import AntDropdown from './Dropdown'
import { isMsie } from 'helpers/browser'
import { getFilterUrl } from 'helpers/filters'

const AntDropdownWrapper = React.forwardRef((props, refToForward) => {
  const router = useRouter()

  const urlTransformer = (url, segment) => getFilterUrl({
    pathname: url,
    page: 1,
    segmentName: segment,
  })

  return (
    <AntDropdown
      isMsie={isMsie()}
      pushRoute={(url) => {
        router.push(url)
      }}
      Link={(linkProps) => {
        const {
          url,
          children,
          refToForward,
          ...resetProps
        } = linkProps

        return (
          <Link href={url}>
            <a
              ref={refToForward}
              {...resetProps}
            >
              {children}
            </a>
          </Link>
        )
      }}
      urlTransformer={urlTransformer}
      {...props}
      ref={refToForward}
    />
  )
})

export default AntDropdownWrapper
